'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CREDIT_CARD_PROCESSING_FEE_NAME = exports.CREDIT_CARD_PROCESSING_FEE_NAME = 'Credit Card Processing Fee';

var calculateCreditCardFee = exports.calculateCreditCardFee = function calculateCreditCardFee() {
  var balanceAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var creditCardFeeObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { percentage: 0, amount: 0 };
  return Number.parseFloat(((balanceAmount + creditCardFeeObject.amount) / (1 - creditCardFeeObject.percentage) - balanceAmount).toFixed(2));
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/utilities/fees.js
// module id = 712
// module chunks = 0